// tslint:disable:no-empty-interface
// tslint:disable:max-line-length
// tslint:disable: no-use-before-declare
import {ITCIApplicationRequest, ITCIApplicationResponse} from "./tci-tenant";
import {TCITenantAppType} from "./tci-application";

export interface ITCIApplicationsAuditRequest extends ITCIApplicationRequest {

}
/*************************************************************************************************/
/*                        TCI Application Audit                                                  */
/*************************************************************************************************/
export interface ITCIApplicationAuditRecords {
    /**
     * total number of records
     */
    totalNum: number;
    /**
     * List of audit records
     */
    audits: ITCIApplicationAuditRecord[];
    /**
     * Query Locator
     */
    queryLocator: string;
}

/**
 * interface IDSApplicationAuditRecord
 */
export interface ITCIApplicationAuditRecord {
    /**
     * Application Id
     */
    appId: string;
    /**
     * created time
     */
    createdTime: number;
    /**
     * user id
     */
    userId: string;
    /**
     * user name
     */
    userName: string;
    /**
     * audit action type
     */
    action: TCIApplicationAuditActionType;
    /**
     * action summary
     */
    actionSummary: string;
    /**
     * status code
     */
    statusCode: string;
    /**
     * duration
     */
    duration: number;
    /**
     * pushing Duration
     */
    pushingDuration: ITCIApplicationAuditPushDuration;
    /**
     * app type
     */
    appType: TCITenantAppType;
    /**
     * subscription id
     */
    gsbc: string;
    /**
     * client id
     */
    client: string;
}

/**
 * interface IDSApplicationAuditPushDuration
 */
export interface ITCIApplicationAuditPushDuration {
    /**
     * Prep Duration
     */
    prep: number;
    /**
     * Validate Duration
     */
    validate: number;
    /**
     * Build Duration
     */
    build: number;
    /**
     * Scale Duration
     */
    scale: number;
}

/**
 * Audit action property type enumeration
 * @type {{[K in string]: K}}
 */
export class TCIApplicationAuditActionType {
    public static APP_CREATE = new TCIApplicationAuditActionType("APP_CREATE");
    public static APP_PUSH = new TCIApplicationAuditActionType("APP_PUSH");
    public static ENDPOINT_VISIBILITY = new TCIApplicationAuditActionType("ENDPOINT_VISIBILITY");
    public static DEPLOYMENT_STAGE = new TCIApplicationAuditActionType("DEPLOYMENT_STAGE");

    private constructor(private value: string) {
    }

    public toString() {
        return this.value;
    }
}

export interface ITCIApplicationAuditResponse extends ITCIApplicationResponse {
    msg: string;
    success: boolean;
    result: ITCIApplicationAuditRecords | any;
}

